// Recommended SEO slugs for the 16-course structure (see "SEO URLs.pdf").
// Keyed by the exact course title as entered in the admin dashboard
// (case-insensitive, whitespace-trimmed) so titles can be matched reliably
// without needing a dedicated "slug" column in the backend.
const COURSE_SLUG_MAP = {
  '3-day automatic intensive': '3-day-automatic-intensive',
  '3-day manual intensive': '3-day-manual-intensive',
  '5-day automatic intensive': '5-day-automatic-intensive',
  '5-day manual intensive': '5-day-manual-intensive',
  '7-day automatic intensive': '7-day-automatic-intensive',
  '7-day manual intensive': '7-day-manual-intensive',
  '10-day automatic intensive': '10-day-automatic-intensive',
  '10-day manual intensive': '10-day-manual-intensive',
  'complete 10-day automatic course': 'complete-10-day-automatic-course',
  'complete 10-day manual course': 'complete-10-day-manual-course',
  'automatic test day': 'automatic-driving-test-day',
  'manual test day': 'manual-driving-test-day',
  'introduction course – automatic': 'automatic-driving-introduction',
  'introduction course - automatic': 'automatic-driving-introduction',
  'introduction course – manual': 'manual-driving-introduction',
  'introduction course - manual': 'manual-driving-introduction',

  // The PDF listed these two as single (non-split) products, but they're
  // actually sold as separate Automatic/Manual courses at different prices
  // (see the course price sheet), so each gets its own Automatic/Manual URL
  // instead of sharing the PDF's single slug.
  '10-hour driving lesson block – automatic': '10-hour-driving-lessons-automatic',
  '10-hour driving lesson block - automatic': '10-hour-driving-lessons-automatic',
  '10-hour driving lesson block – manual': '10-hour-driving-lessons-manual',
  '10-hour driving lesson block - manual': '10-hour-driving-lessons-manual',
  '2-hour introduction lesson – automatic': '2-hour-driving-introduction-automatic',
  '2-hour introduction lesson - automatic': '2-hour-driving-introduction-automatic',
  '2-hour introduction lesson – manual': '2-hour-driving-introduction-manual',
  '2-hour introduction lesson - manual': '2-hour-driving-introduction-manual',
};

// Generic fallback for any course title that isn't one of the 16 above
// (legacy courses, or new ones added before the slug map is updated).
function slugify(text) {
  return String(text || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function getCourseSlug(course) {
  const title = (course?.title || '').trim().toLowerCase();
  return COURSE_SLUG_MAP[title] || slugify(course?.title);
}

export function findCourseBySlug(courses, slug) {
  if (!Array.isArray(courses) || !slug) return null;
  const target = String(slug).toLowerCase();
  return (
    courses.find((course) => getCourseSlug(course) === target) || null
  );
}
